import { gql } from '@apollo/client';
import { PROPERTY_COMPLETE_DATA_FRAGMENT } from 'graphql/property/fragments';
import { USER_BASIC_FIELDS, ID_NAME_FIELDS } from 'graphql/common/fragments';

export const PROPERTY_SET_FRAGMENT = gql`
  fragment propertySetAttributes on PropertySet {
    id
    name
    userId
    fileId
    createdAt
    type
    targetTenant {
      ${ID_NAME_FIELDS}
      headquarters
      industry {
        ${ID_NAME_FIELDS}
      }
    }
    targetProperty {
      ...propertyCompleteDataFragment
    }
    properties {
      id
      order
      name
      featured
      primaryAddress
      displayAddress
      latitude
      longitude
      latitudeDisplay
      longitudeDisplay
      coverMediaUrl
      coverMediaType
      propertyType {
        ${ID_NAME_FIELDS}
      }
      propertySubtype {
        ${ID_NAME_FIELDS}
      }
      propertyClass {
        ${ID_NAME_FIELDS}
      }
      market {
        ${ID_NAME_FIELDS}
      }
      submarket {
        ${ID_NAME_FIELDS}
      }
      micromarket {
        ${ID_NAME_FIELDS}
      }
      owners {
        ${ID_NAME_FIELDS}
      }
    }
    metadata {
      propertySetId
      propertyId
      availabilitiesCount
      rentRangeMin
      rentRangeMax
      sizeRangeMin
      sizeRangeMinMt
      sizeRangeMax
      sizeRangeMaxMt
    }
    user {
      ${USER_BASIC_FIELDS}
      profileImageUrl
    }
    sharedUsers {
      id
      email
      profileImageUrl
    }
    owners {
      id
    }
  }
  ${PROPERTY_COMPLETE_DATA_FRAGMENT}
`;
